import { useState, useEffect } from 'react'
import { CALL_STATUSES } from '../../data/constants.jsx'
import apiService from '../../services/api'

/**
 * CallingHistory Component
 * Simple display of today's calling history for a phone number
 */
const CallingHistory = ({ phoneNumber }) => {
  const [callHistory, setCallHistory] = useState(null)
  const [loading, setLoading] = useState(true)
  const [lastFetchedNumber, setLastFetchedNumber] = useState(null)

  useEffect(() => {
    const fetchCallHistory = async () => {
      if (!phoneNumber) {
        setLoading(false)
        return
      }

      // Prevent refetching same phone number
      if (phoneNumber === lastFetchedNumber) {
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        const data = await apiService.getTodayCallStatus(phoneNumber)
        setCallHistory(data)
        setLastFetchedNumber(phoneNumber)
      } catch (err) {
        console.error('Failed to fetch call history:', err)
        setCallHistory({ total_calls_received: 0, calls: [] })
        setLastFetchedNumber(phoneNumber)
      } finally {
        setLoading(false)
      }
    }

    fetchCallHistory()
  }, [phoneNumber, lastFetchedNumber])

  // Get status label from CALL_STATUSES
  const getStatusLabel = (statusId) => {
    const statusObj = CALL_STATUSES.find(s => s.id === statusId)
    return statusObj?.label || 'অজানা'
  }

  // Format time
  const formatTime = (datetime) => {
    return new Date(datetime).toLocaleTimeString('bn-BD', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    })
  }

  if (loading) {
    return (
      <div className="bg-gray-50 rounded p-3">
        <div className="text-sm text-gray-600">আজকের কল ইতিহাস লোড হচ্ছে...</div>
      </div>
    )
  }

  if (!callHistory || callHistory.total_calls_received === 0) {
    return (
      <div className="bg-gray-50 rounded p-3">
        <div className="text-sm text-gray-600">No one yet called this number</div>
      </div>
    )
  }

  return (
    <div className="bg-gray-50 rounded p-3">
      <div className="text-sm font-medium text-gray-700 mb-2">
        আজকের কল ইতিহাস ({callHistory.total_calls_received})
      </div>
      
      <div className="space-y-1">
        {callHistory.calls.map((call, index) => (
          <div key={index} className="text-xs text-gray-600 flex justify-between">
            <span>{call.user_number__first_name || 'ব্যবহারকারী'}</span>
            <span>{formatTime(call.date_time)}</span>
            <span>{getStatusLabel(call.status_after_calling)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CallingHistory